/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/plus";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "Plus";
export { I as Plus };
